<div class="dialog-header">
    @if (showComplementaryFields) {
    <h2>ALERTA DE SEGURANÇA DA PLATAFORMA</h2>
    <h3>Seu cadastro é necessário apenas para simular os valores de impressão do livro, com segurança e proteção contra
        fraudes, links maliciosos e vírus. Após o cadastro poderá fazer quantas simulações quiser
        gratuitamente.<mat-icon class="title-icon">warning</mat-icon></h3>
    }
    @else {
    <h2>Cadastrar-se</h2>
    <h3>Centenas de autores e leitores dos melhores livros do Brasil adoram a Feira do Livro</h3>
    }
</div>

<mat-dialog-content>
    <form id="userRegisterForm" [formGroup]="model" (ngSubmit)="register()">
        @if (!isEditComplementaryMode) {
        <mat-form-field appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput formControlName="name" type="text" focus>
            @if (model.get('name')?.invalid) {
            <mat-error>Informe seu nome</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" type="text">
            @if (model.get('email')?.invalid) {
            <mat-error>Informe seu email</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>CPF</mat-label>
            <input matInput formControlName="cpf" type="text" mask="000.000.000-00">
            @if (model.get('cpf')?.invalid) {
            <mat-error>Informe um CPF válido</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Telefone celular</mat-label>
            <input matInput formControlName="phone" type="text" mask="(99)99999-9999">
            @if (model.get('phone')?.invalid) {
            <mat-error>Informe seu telefone celular</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Senha</mat-label>
            <input matInput [type]="hideSenha() ? 'password' : 'text'" formControlName="password">
            <button type="button" mat-icon-button matSuffix (click)="clickEventSenha1($event)"
                [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideSenha()">
                <mat-icon>{{hideSenha() ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            @if (model.get('password')?.invalid) {
            <mat-error>Informe sua senha</mat-error>
            }
        </mat-form-field>
        }

        @if (showComplementaryFields) {
        <mat-form-field appearance="outline">
            <mat-label>Que livro quer publicar?</mat-label>
            <mat-select formControlName="publicationBookType">
                @for (opt of bookTypeOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                }
            </mat-select>
            @if (model.get('publicationBookType')?.invalid) {
            <mat-error>Selecione uma opção</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Seu TEXTO já está pronto?</mat-label>
            <mat-select formControlName="publicationTextReady">
                @for (opt of textReadyOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                }
            </mat-select>
            @if (model.get('publicationTextReady')?.invalid) {
            <mat-error>Selecione uma opção</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Quando quer publicar?</mat-label>
            <mat-select formControlName="publicationTimeframe">
                @for (opt of timeframeOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                }
            </mat-select>
            @if (model.get('publicationTimeframe')?.invalid) {
            <mat-error>Selecione uma opção</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Qual é seu orçamento disponível?</mat-label>
            <mat-select formControlName="publicationBudget">
                @for (opt of budgetOptions; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                }
            </mat-select>
            @if (model.get('publicationBudget')?.invalid) {
            <mat-error>Selecione uma opção</mat-error>
            }
        </mat-form-field>
        }
    </form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
    <button type="submit" form="userRegisterForm" mat-flat-button class="btn-primary">
        @if (_isLoading == true) {
        <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
        @else{
        {{ isEditComplementaryMode ? 'Salvar' : 'Cadastrar' }}
        }
    </button>

    @if (!isEditComplementaryMode) {
    <button class="btn-login" mat-flat-button (click)="openModalLogin()">Já possuo uma conta</button>
    }
</mat-dialog-actions>